var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":"48px","height":"37px"},on:{"click":function($event){_vm.$emit('click')}}},[_c('line',{attrs:{"x1":"2%","y1":"2%","x2":"98%","y2":"98%","stroke":"blue","stroke-width":"2"}}),_vm._v(" "),_c('line',{attrs:{"x1":"2%","y1":"98%","x2":"98%","y2":"2%","stroke":"blue","stroke-width":"2"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a4633978","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CloseIcon.vue
// module id = null
// module chunks = 